import React from 'react';
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n";
import { initConsoleEasterEgg } from "./utils/consoleEasterEgg";

// Initialize console easter egg for curious developers
initConsoleEasterEgg();

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
